<div class="java-script">
    <div class="row">
        <app-textarea [formGroup]="formGroup()!" [model]="model()?.script || defaultScript"
            [meta]="metaScript"></app-textarea>
    </div>
</div>
